export const round=(x,num_dec)=>{
    if(!num_dec){
        num_dec=4
    }
    let num = 1
    for(let i=0;i<num_dec;i++){
        num = num*10
    } 
    return Math.round((x + Number.EPSILON) * num) / num
}


export const isValidDate = (d_str) => {
    let res = false
    try{
        let d_str_split = d_str.split('/')
        let d = new Date(d_str_split[1]+'/'+d_str_split[0]+'/'+d_str_split[2]);
        if (!isNaN(d.getTime())){
        res = true
        }
        if(d_str_split[2].length<2 || d_str_split[2].length>4 || d_str_split[0].length>2 || d_str_split[1].length>2){
            res = false
        }
    }
    catch(err){
        res = false
    }
    return res
}

export const sleep = async (ms) => new Promise(
    (resolve) => setTimeout(resolve, ms)
);


export const dateIsInPaths = (date, paths) => {
    for (let i in paths) {
        if (Date.parse(paths[i]['max_date']) >= Date.parse(date) && Date.parse(date) >= Date.parse(paths[i]['min_date'])) {
            return true;
        }
    }
    return false;
}
